"use client";

import React, { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Forward to Sentry/logging — never expose internals to the DOM.
    console.error("Global app error:", error);
  }, [error]);

  return (
    <html lang="en">
      <body style={{ margin: 0, background: "#020617", color: "#e5e7eb", fontFamily: "system-ui, sans-serif" }}>
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div style={{ maxWidth: 480, width: "100%", background: "rgba(2,6,23,0.9)", border: "1px solid rgba(51,65,85,0.6)", borderRadius: 20, padding: "28px 24px" }}>
            {/* Icon */}
            <div style={{ width: 48, height: 48, borderRadius: 14, background: "rgba(239,68,68,0.12)", border: "1px solid rgba(239,68,68,0.25)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "#f1f5f9" }}>Application error</h1>
            <p style={{ marginTop: 8, marginBottom: 0, fontSize: 14, lineHeight: 1.6, color: "#94a3b8" }}>
              Something went wrong and the page couldn&apos;t load. Try refreshing — if the problem continues, please contact support.
            </p>
            {/* Show only the digest (a safe hash for log correlation, no internals) */}
            {error?.digest ? (
              <p style={{ marginTop: 12, fontSize: 11, fontFamily: "monospace", color: "#475569" }}>
                Ref: {error.digest}
              </p>
            ) : null}
            <div style={{ display: "flex", gap: 8, marginTop: 20, flexWrap: "wrap" }}>
              <button
                onClick={() => reset()}
                style={{ border: 0, cursor: "pointer", background: "#10b981", color: "#020617", padding: "10px 18px", borderRadius: 999, fontWeight: 700, fontSize: 14 }}
              >
                Try again
              </button>
              {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- global-error replaces
                  the root layout so the Next.js Link component may not be available here. */}
              <a
                href="/"
                style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", textDecoration: "none", border: "1px solid rgba(51,65,85,0.8)", background: "rgba(15,23,42,0.6)", color: "#e2e8f0", padding: "10px 18px", borderRadius: 999, fontWeight: 700, fontSize: 14 }}
              >
                Go home
              </a>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
